export default __webpack_public_path__ + "static/media/486.858b9231.gif";